import { render, staticRenderFns } from "./projectIntroduce.vue?vue&type=template&id=c6741edc&scoped=true"
import script from "./projectIntroduce.vue?vue&type=script&lang=js"
export * from "./projectIntroduce.vue?vue&type=script&lang=js"
import style0 from "./projectIntroduce.vue?vue&type=style&index=0&id=c6741edc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6741edc",
  null
  
)

export default component.exports